<div>
  <h1>{{code}}</h1>

  <h2>{{'main.500.error' | translate}}</h2>

  <p>{{message}}</p>

  <button [routerLink]="['/auth', 'login']">{{'main.500.login' | translate}}</button>
</div>
